import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router';

import { APP_SETTINGS } from '@constants/constants';
import { initHubSpotChatWidget } from '@utils/hubspot';
import { initializeOpenReplay } from '@utils/openreplay';

import { App } from './App';
import './index.css';
import './stylesheets/openreplay-debug.scss';

if (APP_SETTINGS.sentryDSN) {
  Sentry.init({
    dsn: APP_SETTINGS.sentryDSN,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [APP_SETTINGS.baseUrlRegex, APP_SETTINGS.apiurl],
    environment: APP_SETTINGS.keycloakRealm,
    sendDefaultPii: false,
    release: process.env.VITE_VERCEL_GIT_COMMIT_SHA,
    // Session replays are disabled here; we rely on OpenReplay for general
    // session reviewability. Only error replays are captured (see below).
    replaysSessionSampleRate: 0,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
  });
}

// Initialize OpenReplay tracker
initializeOpenReplay();

// Initialize HubSpot Chat widget
initHubSpotChatWidget();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Router>
    <App />
  </Router>,
);
